// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.crystal-navbar-container {
  position: relative;
  z-index: 1000;
}

/* ==========================================================================
   1. PERSISTENT SLIM ICON DOCK (64px - Always visible on all pages)
   ========================================================================== */
.crystal-slim-rail {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 64px;
  background: #ffffff;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eaecf0;
  box-shadow: 1px 0 6px rgba(0, 0, 0, 0.02);
  -webkit-user-select: none;
          user-select: none;
}
.crystal-slim-rail .rail-brand {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}
.crystal-slim-rail .rail-brand .brand-badge {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(108, 11, 169, 0.15);
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
  padding: 3px;
}
.crystal-slim-rail .rail-brand .brand-badge .brand-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}
.crystal-slim-rail .rail-brand .brand-badge .brand-icon {
  color: #ffffff;
  font-size: 24px;
}
.crystal-slim-rail .rail-brand .brand-badge:hover {
  transform: scale(1.08);
}
.crystal-slim-rail .rail-nav-list {
  flex: 1;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  overflow-y: auto;
}
.crystal-slim-rail .rail-nav-list::-webkit-scrollbar {
  width: 0px;
}
.crystal-slim-rail .dock-item {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  padding: 0;
}
.crystal-slim-rail .dock-item .dock-icon-box {
  position: relative;
  font-size: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.crystal-slim-rail .dock-item .dock-icon-box .badge-dot {
  position: absolute;
  top: -2px;
  right: -4px;
  width: 8px;
  height: 8px;
  background-color: #22c55e;
  border: 2px solid #ffffff;
  border-radius: 50%;
}
.crystal-slim-rail .dock-item .dock-label {
  font-size: 9.5px;
  font-weight: 500;
  margin-top: 3px;
  letter-spacing: -0.2px;
  line-height: 1;
}
.crystal-slim-rail .dock-item:hover {
  background: #f1f5f9;
  color: #1c2b36;
}
.crystal-slim-rail .dock-item.active {
  background: #f5ebfc;
  color: #6c0ba9;
  font-weight: 600;
}
.crystal-slim-rail .dock-item.active::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 10px;
  bottom: 10px;
  width: 4px;
  background: #6c0ba9;
  border-radius: 0 4px 4px 0;
}
.crystal-slim-rail .rail-footer {
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #f1f5f9;
}
.crystal-slim-rail .rail-footer .toggle-btn {
  color: #64748b;
}
.crystal-slim-rail .rail-footer .toggle-btn:hover {
  color: #6c0ba9;
  background: #f5ebfc;
}
.crystal-slim-rail .rail-footer .rail-user-container {
  position: relative;
}
.crystal-slim-rail .rail-footer .rail-user-container .dock-avatar-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  transition: border-color 0.2s ease;
}
.crystal-slim-rail .rail-footer .rail-user-container .dock-avatar-btn .avatar-circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #6c0ba9 0%, #8b2fc9 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.crystal-slim-rail .rail-footer .rail-user-container .dock-avatar-btn:hover {
  border-color: #6c0ba9;
}

/* ==========================================================================
   2. SECONDARY FLOATING DRAWER PANEL (240px)
   ========================================================================== */
.drawer-backdrop {
  position: fixed;
  top: 0;
  left: 64px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.2);
  backdrop-filter: blur(2px);
  z-index: 999;
  animation: backdropFade 0.2s ease;
}

@keyframes backdropFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.crystal-secondary-drawer {
  position: fixed;
  top: 0;
  left: 64px;
  bottom: 0;
  width: 240px;
  background: linear-gradient(180deg, #fdf2f8 0%, #f5eefb 60%, #edf4ff 100%);
  z-index: 1000;
  border-right: 1px solid #eaecf0;
  box-shadow: 4px 0 16px rgba(0, 0, 0, 0.04);
  transform: translateX(-100%);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
  display: flex;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
}
.crystal-secondary-drawer.open {
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
}
.crystal-secondary-drawer .drawer-header {
  height: 60px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}
.crystal-secondary-drawer .drawer-header .drawer-title-box {
  display: flex;
  flex-direction: column;
}
.crystal-secondary-drawer .drawer-header .drawer-title-box .drawer-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #6c0ba9;
}
.crystal-secondary-drawer .drawer-header .drawer-title-box .drawer-heading {
  font-size: 15px;
  font-weight: 700;
  color: #1c2b36;
  margin: 0;
  line-height: 1.2;
}
.crystal-secondary-drawer .drawer-header .drawer-header-actions {
  display: flex;
  gap: 4px;
}
.crystal-secondary-drawer .drawer-header .drawer-header-actions .header-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s ease;
}
.crystal-secondary-drawer .drawer-header .drawer-header-actions .header-icon-btn:hover {
  background: #f1f5f9;
  color: #1c2b36;
}
.crystal-secondary-drawer .drawer-header .drawer-header-actions .header-icon-btn.pinned {
  color: #6c0ba9;
  background: #f5ebfc;
}
.crystal-secondary-drawer .drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 12px;
  /* Submenu Folder Container (Light pinky-purpuly gradient pill) */
}
.crystal-secondary-drawer .drawer-body::-webkit-scrollbar {
  width: 4px;
}
.crystal-secondary-drawer .drawer-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.crystal-secondary-drawer .drawer-body .submenu-folder-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f7e6f8 0%, #ede0f9 100%);
  border: 1px solid #e0cbe8;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(108, 11, 169, 0.06);
}
.crystal-secondary-drawer .drawer-body .submenu-folder-card .folder-icon {
  font-size: 16px;
  color: #6c0ba9;
}
.crystal-secondary-drawer .drawer-body .submenu-folder-card .folder-mini-logo {
  width: 22px;
  height: 22px;
  object-fit: contain;
  border-radius: 4px;
}
.crystal-secondary-drawer .drawer-body .submenu-folder-card .folder-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #51087e;
  letter-spacing: 0.2px;
}
.crystal-secondary-drawer .drawer-body .pane-links {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  text-decoration: none;
  color: #1c2b36;
  cursor: pointer;
  transition: all 0.15s ease;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-icon.teal {
  background: #e6f4f1;
  color: #008069;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-icon.blue {
  background: #e0f2fe;
  color: #0284c7;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-icon.purple {
  background: #f5ebfc;
  color: #6c0ba9;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-icon.amber {
  background: #fef3c7;
  color: #d97706;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-icon.emerald {
  background: #dcfce7;
  color: #16a34a;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-info {
  display: flex;
  flex-direction: column;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-info .pane-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #1c2b36;
  line-height: 1.2;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item .pane-info .pane-desc {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item:hover {
  background: #ffffff;
  transform: translateX(2px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item:hover .pane-title {
  color: #6c0ba9;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item.routeColor {
  background: #f5ebfc;
}
.crystal-secondary-drawer .drawer-body .pane-links .pane-item.routeColor .pane-title {
  color: #6c0ba9;
  font-weight: 700;
}

/* ==========================================================================
   3. TOP NAVIGATION BAR WITH DYNAMIC BREADCRUMB & LIVE DATE/TIME WIDGET
   ========================================================================== */
.crystal-top-bar {
  position: fixed;
  top: 0;
  left: 64px;
  right: 0;
  height: 60px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  z-index: 999;
  border-bottom: 1px solid #eaecf0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  transition: left 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.crystal-top-bar .bar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
.crystal-top-bar .bar-left .mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  font-size: 18px;
  color: #1c2b36;
  cursor: pointer;
  padding: 4px;
}
.crystal-top-bar .bar-left .brand-title-group {
  display: flex;
  align-items: center;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail {
  display: flex;
  align-items: center;
  gap: 8px;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail .breadcrumb-root {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail .breadcrumb-root .brand-mini-icon {
  color: #6c0ba9;
  font-size: 15px;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail .breadcrumb-root .brand-mini-logo {
  width: 22px;
  height: 22px;
  object-fit: contain;
  border-radius: 4px;
  vertical-align: middle;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail .breadcrumb-sub {
  font-size: 13.5px;
  font-weight: 600;
  color: #475569;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail .breadcrumb-sep {
  font-size: 10px;
  color: #cbd5e1;
}
.crystal-top-bar .bar-left .brand-title-group .breadcrumb-trail .breadcrumb-current {
  font-size: 17px;
  font-weight: 800;
  color: #1c2b36;
  letter-spacing: -0.3px;
}
.crystal-top-bar .bar-right {
  display: flex;
  align-items: center;
  gap: 16px;
  /* LIVE DATE & TIME WIDGET nearby Profile Icon */
  /* USER PROFILE WIDGET (Single round avatar icon button) */
}
.crystal-top-bar .bar-right .live-datetime-widget {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px;
  background: linear-gradient(135deg, #fcf2f8 0%, #f5ebfc 100%);
  border: 1px solid #e0cbe8;
  border-radius: 20px;
  font-size: 12.5px;
  color: #1c2b36;
}
.crystal-top-bar .bar-right .live-datetime-widget .datetime-pill {
  display: flex;
  align-items: center;
  gap: 6px;
}
.crystal-top-bar .bar-right .live-datetime-widget .datetime-icon {
  color: #6c0ba9;
  font-size: 13px;
}
.crystal-top-bar .bar-right .live-datetime-widget .datetime-text {
  white-space: nowrap;
  font-weight: 500;
}
.crystal-top-bar .bar-right .live-datetime-widget .time-highlight {
  color: #6c0ba9;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.crystal-top-bar .bar-right .live-datetime-widget .datetime-sep {
  color: #cbd5e1;
  font-weight: 300;
  font-size: 12px;
}
.crystal-top-bar .bar-right .crystal-user-container {
  position: relative;
}
.crystal-top-bar .bar-right .crystal-user-container .crystal-user-profile-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 50%;
  border: 2px solid transparent;
  background: transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.crystal-top-bar .bar-right .crystal-user-container .crystal-user-profile-btn:hover {
  border-color: #6c0ba9;
  transform: scale(1.05);
}
.crystal-top-bar .bar-right .crystal-user-container .crystal-user-profile-btn .user-avatar-circle {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6c0ba9 0%, #8b2fc9 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 13.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 10px rgba(108, 11, 169, 0.25);
}
.crystal-top-bar .bar-right .crystal-user-container .crystal-user-profile-btn .user-avatar-circle .online-indicator {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 10px;
  height: 10px;
  background: #22c55e;
  border: 2px solid #ffffff;
  border-radius: 50%;
}

/* USER POPOVER CARD */
.user-popover-card {
  position: absolute;
  right: 0;
  top: 48px;
  width: 240px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #eaecf0;
  padding: 8px 0;
  z-index: 1010;
  animation: popoverSlideDown 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.user-popover-card .popover-user-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
}
.user-popover-card .popover-user-header .popover-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6c0ba9 0%, #8b2fc9 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-popover-card .popover-user-header .popover-user-details {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.user-popover-card .popover-user-header .popover-user-details .popover-user-name {
  font-size: 14px;
  font-weight: 700;
  color: #1c2b36;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-popover-card .popover-user-header .popover-user-details .popover-user-company {
  font-size: 11.5px;
  color: #64748b;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-popover-card .popover-user-header .popover-user-details .popover-user-company i {
  color: #6c0ba9;
  margin-right: 3px;
}
.user-popover-card .popover-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 6px 0;
}
.user-popover-card .popover-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #1c2b36;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease;
}
.user-popover-card .popover-nav-item i {
  font-size: 15px;
  color: #64748b;
  width: 18px;
}
.user-popover-card .popover-nav-item:hover {
  background: #f5ebfc;
  color: #6c0ba9;
}
.user-popover-card .popover-nav-item:hover i {
  color: #6c0ba9;
}
.user-popover-card .popover-nav-item.logout-link {
  color: #ef4444;
}
.user-popover-card .popover-nav-item.logout-link i {
  color: #ef4444;
}
.user-popover-card .popover-nav-item.logout-link:hover {
  background: #fef2f2;
}

@keyframes popoverSlideDown {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ==========================================================================
   4. LAYOUT ADAPTATIONS & RESPONSIVE BREAKPOINTS
   ========================================================================== */
.crystal-navbar-container.pinned .crystal-top-bar {
  left: calc(64px + 240px);
}

@media screen and (max-width: 768px) {
  .crystal-top-bar {
    left: 64px;
    padding: 0 16px;
  }
  .crystal-top-bar .mobile-menu-btn {
    display: block;
  }
  .crystal-top-bar .breadcrumb-trail .breadcrumb-root, .crystal-top-bar .breadcrumb-trail .breadcrumb-sep {
    display: none;
  }
  .crystal-secondary-drawer {
    box-shadow: 8px 0 24px rgba(0, 0, 0, 0.15);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/whatsapp-navbar/whatsapp-navbar.component.scss"],"names":[],"mappings":"AAmBA;EACE,cAAA;EACA,gGAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,aAAA;AAlBF;;AAqBA;;+EAAA;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,WAnCU;EAoCV,mBArBM;EAsBN,aAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,yCAAA;EACA,yBAAA;UAAA,iBAAA;AAlBF;AAoBE;EACE,YA3Cc;EA4Cd,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAzCE;EA0CF,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,4DAAA;EACA,gBAAA;EACA,YAAA;AAlBN;AAoBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAlBR;AAqBM;EACE,cA1DA;EA2DA,eAAA;AAnBR;AAsBM;EACE,sBAAA;AApBR;AAyBE;EACE,OAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,UAAA;AAvBN;AA2BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAhGY;EAiGZ,eAAA;EACA,iDAAA;EACA,aAAA;EACA,UAAA;AAzBJ;AA2BI;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzBN;AA2BM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAzBR;AA6BI;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AA3BN;AA8BI;EACE,mBAAA;EACA,cApIQ;AAwGd;AA+BI;EACE,mBA5IQ;EA6IR,cA/IU;EAgJV,gBAAA;AA7BN;AA+BM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,mBAzJQ;EA0JR,0BAAA;AA7BR;AAkCE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AAhCJ;AAkCI;EACE,cAjKU;AAiIhB;AAiCM;EACE,cA1KQ;EA2KR,mBAzKM;AA0Id;AAmCI;EACE,kBAAA;AAjCN;AAmCM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,kCAAA;AAjCR;AAmCQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DA5LO;EA6LP,cAvLF;EAwLE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCV;AAoCQ;EACE,qBA1MM;AAwKhB;;AAyCA;;+EAAA;AAGA;EACE,eAAA;EACA,MAAA;EACA,UA5NU;EA6NV,QAAA;EACA,SAAA;EACA,iCAAA;EACA,0BAAA;EACA,YAAA;EACA,iCAAA;AAtCF;;AAyCA;EACE;IAAO,UAAA;EArCP;EAsCA;IAAK,UAAA;EAnCL;AACF;AAqCA;EACE,eAAA;EACA,MAAA;EACA,UA7OU;EA8OV,SAAA;EACA,YA9OY;EA+OZ,0EAAA;EACA,aAAA;EACA,+BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2EAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AAnCF;AAqCE;EACE,wBAAA;EACA,UAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE,YAhQc;EAiQd,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBAzPI;AAqNR;AAsCI;EACE,aAAA;EACA,sBAAA;AApCN;AAsCM;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cA9QQ;AA0OhB;AAuCM;EACE,eAAA;EACA,gBAAA;EACA,cA9QM;EA+QN,SAAA;EACA,gBAAA;AArCR;AAyCI;EACE,aAAA;EACA,QAAA;AAvCN;AAyCM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cA7RQ;EA8RR,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AAvCR;AAyCQ;EACE,mBAAA;EACA,cAxSI;AAiQd;AA0CQ;EACE,cAlTM;EAmTN,mBAjTI;AAyQd;AA8CE;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EAUA,iEAAA;AArDJ;AA6CI;EACE,UAAA;AA3CN;AA6CI;EACE,mBAAA;EACA,kBAAA;AA3CN;AA+CI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AA7CN;AA+CM;EACE,eAAA;EACA,cApVQ;AAuShB;AAgDM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA9CR;AAiDM;EACE,iBAAA;EACA,gBAAA;EACA,cAhWK;EAiWL,qBAAA;AA/CR;AAmDI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAjDN;AAmDM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cA7WM;EA8WN,eAAA;EACA,0BAAA;AAjDR;AAmDQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAjDV;AAmDU;EAAS,mBAAA;EAAqB,cAAA;AA/CxC;AAgDU;EAAS,mBAAA;EAAqB,cAAA;AA5CxC;AA6CU;EAAW,mBAjYP;EAiYiC,cAnY/B;AA0VhB;AA0CU;EAAU,mBAAA;EAAqB,cAAA;AAtCzC;AAuCU;EAAY,mBAAA;EAAqB,cAAA;AAnC3C;AAsCQ;EACE,aAAA;EACA,sBAAA;AApCV;AAsCU;EACE,iBAAA;EACA,gBAAA;EACA,cAzYE;EA0YF,gBAAA;AApCZ;AAuCU;EACE,eAAA;EACA,cA9YI;EA+YJ,eAAA;AArCZ;AAyCQ;EACE,mBAjZF;EAkZE,0BAAA;EACA,yCAAA;AAvCV;AAyCU;EACE,cAhaI;AAyXhB;AA2CQ;EACE,mBAnaI;AA0Xd;AA2CU;EACE,cAxaI;EAyaJ,gBAAA;AAzCZ;;AAiDA;;+EAAA;AAGA;EACE,eAAA;EACA,MAAA;EACA,UA5bU;EA6bV,QAAA;EACA,YA5bgB;EA6bhB,qCAAA;EACA,2BAAA;EACA,YAAA;EACA,gCAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mDAAA;AA9CF;AAgDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9CJ;AAgDI;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAzcQ;EA0cR,eAAA;EACA,YAAA;AA9CN;AAiDI;EACE,aAAA;EACA,mBAAA;AA/CN;AAiDM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA/CR;AAiDQ;EACE,eAAA;EACA,gBAAA;EACA,cAzdM;EA0dN,aAAA;EACA,mBAAA;EACA,QAAA;AA/CV;AAiDU;EACE,cAteI;EAueJ,eAAA;AA/CZ;AAkDU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAhDZ;AAoDQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAlDV;AAqDQ;EACE,eAAA;EACA,cAAA;AAnDV;AAsDQ;EACE,eAAA;EACA,gBAAA;EACA,cA3fI;EA4fJ,sBAAA;AApDV;AA0DE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,gDAAA;EAyCA,0DAAA;AAjGJ;AAyDI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAjhBQ;AA0dd;AAyDM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAvDR;AA0DM;EACE,cAhiBQ;EAiiBR,eAAA;AAxDR;AA2DM;EACE,mBAAA;EACA,gBAAA;AAzDR;AA4DM;EACE,cA1iBQ;EA2iBR,gBAAA;EACA,kCAAA;AA1DR;AA6DM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA3DR;AAgEI;EACE,kBAAA;AA9DN;AAgEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AA9DR;AAgEQ;EACE,qBAtkBM;EAukBN,sBAAA;AA9DV;AAiEQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DA3kBO;EA4kBP,cAtkBF;EAukBE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;AA/DV;AAiEU;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA/DZ;;AAuEA,sBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBApmBM;EAqmBN,mBAAA;EACA,0EAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,6DAAA;AApEF;AAsEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AApEJ;AAsEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DA5nBW;EA6nBX,cAvnBE;EAwnBF,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApEN;AAuEI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AArEN;AAuEM;EACE,eAAA;EACA,gBAAA;EACA,cA3oBM;EA4oBN,mBAAA;EACA,gBAAA;EACA,uBAAA;AArER;AAwEM;EACE,iBAAA;EACA,cAlpBQ;EAmpBR,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtER;AAwEQ;EACE,cAhqBM;EAiqBN,iBAAA;AAtEV;AA4EE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cA9qBU;EA+qBV,qBAAA;EACA,eAAA;EACA,iCAAA;AA3EJ;AA6EI;EACE,eAAA;EACA,cAprBU;EAqrBV,WAAA;AA3EN;AA8EI;EACE,mBA9rBQ;EA+rBR,cAjsBU;AAqnBhB;AA6EM;EACE,cAnsBQ;AAwnBhB;AA+EI;EACE,cAAA;AA7EN;AA8EM;EACE,cAAA;AA5ER;AA8EM;EACE,mBAAA;AA5ER;;AAkFA;EACE;IACE,UAAA;IACA,0BAAA;EA/EF;EAiFA;IACE,UAAA;IACA,wBAAA;EA/EF;AACF;AAkFA;;+EAAA;AAKI;EACE,wBAAA;AAlFN;;AAuFA;EACE;IACE,UAhvBQ;IAivBR,eAAA;EApFF;EAsFE;IACE,cAAA;EApFJ;EAwFI;IACE,aAAA;EAtFN;EA2FA;IACE,0CAAA;EAzFF;AACF","sourcesContent":["// WhatsappNavbarComponent - Light Meta WhatsApp Manager UI with Purple Accent System\n\n$railWidth: 64px;\n$drawerWidth: 240px;\n$topHeaderHeight: 60px;\n\n// Brand Purple Colors (Original App Purple Highlight)\n$purplePrimary: #6c0ba9;\n$purpleDark: #51087e;\n$purpleLight: #f5ebfc;\n$purpleHover: #5c0991;\n$purpleGradient: linear-gradient(135deg, #6c0ba9 0%, #8b2fc9 100%);\n\n$textPrimary: #1c2b36;\n$textSecondary: #64748b;\n$borderLight: #eaecf0;\n$bgCanvas: #f8f7fa;\n$white: #ffffff;\n\n:host {\n  display: block;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.crystal-navbar-container {\n  position: relative;\n  z-index: 1000;\n}\n\n/* ==========================================================================\n   1. PERSISTENT SLIM ICON DOCK (64px - Always visible on all pages)\n   ========================================================================== */\n.crystal-slim-rail {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: $railWidth;\n  background: $white;\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid $borderLight;\n  box-shadow: 1px 0 6px rgba(0, 0, 0, 0.02);\n  user-select: none;\n\n  .rail-brand {\n    height: $topHeaderHeight;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 1px solid #f1f5f9;\n    cursor: pointer;\n\n    .brand-badge {\n      width: 42px;\n      height: 42px;\n      border-radius: 12px;\n      background: $white;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 4px 12px rgba(108, 11, 169, 0.15);\n      transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n      overflow: hidden;\n      padding: 3px;\n\n      .brand-logo-img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        border-radius: 8px;\n      }\n\n      .brand-icon {\n        color: $white;\n        font-size: 24px;\n      }\n\n      &:hover {\n        transform: scale(1.08);\n      }\n    }\n  }\n\n  .rail-nav-list {\n    flex: 1;\n    padding: 16px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n  }\n\n  .dock-item {\n    position: relative;\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    border: none;\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: $textSecondary;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    outline: none;\n    padding: 0;\n\n    .dock-icon-box {\n      position: relative;\n      font-size: 19px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .badge-dot {\n        position: absolute;\n        top: -2px;\n        right: -4px;\n        width: 8px;\n        height: 8px;\n        background-color: #22c55e;\n        border: 2px solid $white;\n        border-radius: 50%;\n      }\n    }\n\n    .dock-label {\n      font-size: 9.5px;\n      font-weight: 500;\n      margin-top: 3px;\n      letter-spacing: -0.2px;\n      line-height: 1;\n    }\n\n    &:hover {\n      background: #f1f5f9;\n      color: $textPrimary;\n    }\n\n    &.active {\n      background: $purpleLight;\n      color: $purplePrimary;\n      font-weight: 600;\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: -8px;\n        top: 10px;\n        bottom: 10px;\n        width: 4px;\n        background: $purplePrimary;\n        border-radius: 0 4px 4px 0;\n      }\n    }\n  }\n\n  .rail-footer {\n    padding: 12px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    border-top: 1px solid #f1f5f9;\n\n    .toggle-btn {\n      color: $textSecondary;\n      &:hover {\n        color: $purplePrimary;\n        background: $purpleLight;\n      }\n    }\n\n    .rail-user-container {\n      position: relative;\n\n      .dock-avatar-btn {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        border: 2px solid #e2e8f0;\n        background: transparent;\n        padding: 0;\n        cursor: pointer;\n        transition: border-color 0.2s ease;\n\n        .avatar-circle {\n          width: 100%;\n          height: 100%;\n          border-radius: 50%;\n          background: $purpleGradient;\n          color: $white;\n          font-weight: 700;\n          font-size: 13px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n\n        &:hover {\n          border-color: $purplePrimary;\n        }\n      }\n    }\n  }\n}\n\n/* ==========================================================================\n   2. SECONDARY FLOATING DRAWER PANEL (240px)\n   ========================================================================== */\n.drawer-backdrop {\n  position: fixed;\n  top: 0;\n  left: $railWidth;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.2);\n  backdrop-filter: blur(2px);\n  z-index: 999;\n  animation: backdropFade 0.2s ease;\n}\n\n@keyframes backdropFade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.crystal-secondary-drawer {\n  position: fixed;\n  top: 0;\n  left: $railWidth;\n  bottom: 0;\n  width: $drawerWidth;\n  background: linear-gradient(180deg, #fdf2f8 0%, #f5eefb 60%, #edf4ff 100%);\n  z-index: 1000;\n  border-right: 1px solid $borderLight;\n  box-shadow: 4px 0 16px rgba(0, 0, 0, 0.04);\n  transform: translateX(-100%);\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  visibility: hidden;\n\n  &.open {\n    transform: translateX(0);\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .drawer-header {\n    height: $topHeaderHeight;\n    padding: 0 18px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #e2e8f0;\n    background: $white;\n\n    .drawer-title-box {\n      display: flex;\n      flex-direction: column;\n\n      .drawer-kicker {\n        font-size: 10px;\n        font-weight: 700;\n        letter-spacing: 0.6px;\n        text-transform: uppercase;\n        color: $purplePrimary;\n      }\n\n      .drawer-heading {\n        font-size: 15px;\n        font-weight: 700;\n        color: $textPrimary;\n        margin: 0;\n        line-height: 1.2;\n      }\n    }\n\n    .drawer-header-actions {\n      display: flex;\n      gap: 4px;\n\n      .header-icon-btn {\n        width: 30px;\n        height: 30px;\n        border-radius: 8px;\n        border: none;\n        background: transparent;\n        color: $textSecondary;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        transition: all 0.15s ease;\n\n        &:hover {\n          background: #f1f5f9;\n          color: $textPrimary;\n        }\n\n        &.pinned {\n          color: $purplePrimary;\n          background: $purpleLight;\n        }\n      }\n    }\n  }\n\n  .drawer-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 12px;\n\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background: #cbd5e1;\n      border-radius: 4px;\n    }\n\n    /* Submenu Folder Container (Light pinky-purpuly gradient pill) */\n    .submenu-folder-card {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 10px 16px;\n      background: linear-gradient(135deg, #f7e6f8 0%, #ede0f9 100%);\n      border: 1px solid #e0cbe8;\n      border-radius: 8px;\n      margin-bottom: 12px;\n      box-shadow: 0 2px 8px rgba(108, 11, 169, 0.06);\n\n      .folder-icon {\n        font-size: 16px;\n        color: $purplePrimary;\n      }\n\n      .folder-mini-logo {\n        width: 22px;\n        height: 22px;\n        object-fit: contain;\n        border-radius: 4px;\n      }\n\n      .folder-title {\n        font-size: 13.5px;\n        font-weight: 700;\n        color: $purpleDark;\n        letter-spacing: 0.2px;\n      }\n    }\n\n    .pane-links {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      margin-bottom: 16px;\n\n      .pane-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 10px 12px;\n        border-radius: 10px;\n        text-decoration: none;\n        color: $textPrimary;\n        cursor: pointer;\n        transition: all 0.15s ease;\n\n        .pane-icon {\n          width: 34px;\n          height: 34px;\n          border-radius: 8px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 15px;\n          flex-shrink: 0;\n\n          &.teal { background: #e6f4f1; color: #008069; }\n          &.blue { background: #e0f2fe; color: #0284c7; }\n          &.purple { background: $purpleLight; color: $purplePrimary; }\n          &.amber { background: #fef3c7; color: #d97706; }\n          &.emerald { background: #dcfce7; color: #16a34a; }\n        }\n\n        .pane-info {\n          display: flex;\n          flex-direction: column;\n\n          .pane-title {\n            font-size: 13.5px;\n            font-weight: 600;\n            color: $textPrimary;\n            line-height: 1.2;\n          }\n\n          .pane-desc {\n            font-size: 11px;\n            color: $textSecondary;\n            margin-top: 2px;\n          }\n        }\n\n        &:hover {\n          background: $white;\n          transform: translateX(2px);\n          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);\n\n          .pane-title {\n            color: $purplePrimary;\n          }\n        }\n\n        &.routeColor {\n          background: $purpleLight;\n          \n          .pane-title {\n            color: $purplePrimary;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* ==========================================================================\n   3. TOP NAVIGATION BAR WITH DYNAMIC BREADCRUMB & LIVE DATE/TIME WIDGET\n   ========================================================================== */\n.crystal-top-bar {\n  position: fixed;\n  top: 0;\n  left: $railWidth;\n  right: 0;\n  height: $topHeaderHeight;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(10px);\n  z-index: 999;\n  border-bottom: 1px solid $borderLight;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  transition: left 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n\n  .bar-left {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    .mobile-menu-btn {\n      display: none;\n      background: transparent;\n      border: none;\n      font-size: 18px;\n      color: $textPrimary;\n      cursor: pointer;\n      padding: 4px;\n    }\n\n    .brand-title-group {\n      display: flex;\n      align-items: center;\n\n      .breadcrumb-trail {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .breadcrumb-root {\n          font-size: 13px;\n          font-weight: 600;\n          color: $textSecondary;\n          display: flex;\n          align-items: center;\n          gap: 6px;\n\n          .brand-mini-icon {\n            color: $purplePrimary;\n            font-size: 15px;\n          }\n\n          .brand-mini-logo {\n            width: 22px;\n            height: 22px;\n            object-fit: contain;\n            border-radius: 4px;\n            vertical-align: middle;\n          }\n        }\n\n        .breadcrumb-sub {\n          font-size: 13.5px;\n          font-weight: 600;\n          color: #475569;\n        }\n\n        .breadcrumb-sep {\n          font-size: 10px;\n          color: #cbd5e1;\n        }\n\n        .breadcrumb-current {\n          font-size: 17px;\n          font-weight: 800;\n          color: $textPrimary;\n          letter-spacing: -0.3px;\n        }\n      }\n    }\n  }\n\n  .bar-right {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    /* LIVE DATE & TIME WIDGET nearby Profile Icon */\n    .live-datetime-widget {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 5px 14px;\n      background: linear-gradient(135deg, #fcf2f8 0%, #f5ebfc 100%);\n      border: 1px solid #e0cbe8;\n      border-radius: 20px;\n      font-size: 12.5px;\n      color: $textPrimary;\n\n      .datetime-pill {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n      }\n\n      .datetime-icon {\n        color: $purplePrimary;\n        font-size: 13px;\n      }\n\n      .datetime-text {\n        white-space: nowrap;\n        font-weight: 500;\n      }\n\n      .time-highlight {\n        color: $purplePrimary;\n        font-weight: 700;\n        font-variant-numeric: tabular-nums;\n      }\n\n      .datetime-sep {\n        color: #cbd5e1;\n        font-weight: 300;\n        font-size: 12px;\n      }\n    }\n\n    /* USER PROFILE WIDGET (Single round avatar icon button) */\n    .crystal-user-container {\n      position: relative;\n\n      .crystal-user-profile-btn {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 2px;\n        border-radius: 50%;\n        border: 2px solid transparent;\n        background: transparent;\n        cursor: pointer;\n        transition: all 0.15s ease;\n\n        &:hover {\n          border-color: $purplePrimary;\n          transform: scale(1.05);\n        }\n\n        .user-avatar-circle {\n          position: relative;\n          width: 38px;\n          height: 38px;\n          border-radius: 50%;\n          background: $purpleGradient;\n          color: $white;\n          font-weight: 700;\n          font-size: 13.5px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          box-shadow: 0 3px 10px rgba(108, 11, 169, 0.25);\n\n          .online-indicator {\n            position: absolute;\n            bottom: 0px;\n            right: 0px;\n            width: 10px;\n            height: 10px;\n            background: #22c55e;\n            border: 2px solid $white;\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* USER POPOVER CARD */\n.user-popover-card {\n  position: absolute;\n  right: 0;\n  top: 48px;\n  width: 240px;\n  background: $white;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04);\n  border: 1px solid $borderLight;\n  padding: 8px 0;\n  z-index: 1010;\n  animation: popoverSlideDown 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n\n  .popover-user-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n\n    .popover-user-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      background: $purpleGradient;\n      color: $white;\n      font-weight: 700;\n      font-size: 14px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .popover-user-details {\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n\n      .popover-user-name {\n        font-size: 14px;\n        font-weight: 700;\n        color: $textPrimary;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .popover-user-company {\n        font-size: 11.5px;\n        color: $textSecondary;\n        margin-top: 2px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        i {\n          color: $purplePrimary;\n          margin-right: 3px;\n        }\n      }\n    }\n  }\n\n  .popover-divider {\n    height: 1px;\n    background: #f1f5f9;\n    margin: 6px 0;\n  }\n\n  .popover-nav-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    font-size: 13px;\n    font-weight: 500;\n    color: $textPrimary;\n    text-decoration: none;\n    cursor: pointer;\n    transition: background 0.15s ease;\n\n    i {\n      font-size: 15px;\n      color: $textSecondary;\n      width: 18px;\n    }\n\n    &:hover {\n      background: $purpleLight;\n      color: $purplePrimary;\n      i {\n        color: $purplePrimary;\n      }\n    }\n\n    &.logout-link {\n      color: #ef4444;\n      i {\n        color: #ef4444;\n      }\n      &:hover {\n        background: #fef2f2;\n      }\n    }\n  }\n}\n\n@keyframes popoverSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ==========================================================================\n   4. LAYOUT ADAPTATIONS & RESPONSIVE BREAKPOINTS\n   ========================================================================== */\n.crystal-navbar-container {\n  &.pinned {\n    .crystal-top-bar {\n      left: calc(#{$railWidth} + #{$drawerWidth});\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .crystal-top-bar {\n    left: $railWidth;\n    padding: 0 16px;\n\n    .mobile-menu-btn {\n      display: block;\n    }\n\n    .breadcrumb-trail {\n      .breadcrumb-root, .breadcrumb-sep {\n        display: none;\n      }\n    }\n  }\n\n  .crystal-secondary-drawer {\n    box-shadow: 8px 0 24px rgba(0, 0, 0, 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
